module.exports = __webpack_public_path__ + "static/media/field-bale.4290255d.jpg";